<template>
  <a
    class="tracking-wider mb-2 mt-0 cursor-pointer font-normal underline text-blue-light hover:text-blue-200"
    ><slot
  /></a>
</template>
